/**
 * The lifts the front page's picker shows, with what one set of each counts toward, worked
 * out by the app's own rules and written down here so the page does not load the 600 KB
 * exercise list. src/site/landing.test.ts works each one out again from the app and fails
 * when they part.
 */
import type { MuscleId } from '../science/muscles'
import type { Role } from '../science/roles'

export interface LandingLift {
  id: string
  /** The picker's label. */
  short: string
  /** The exercise's name in the app. */
  name: string
  /** What one set counts toward (src/science/roles.ts). */
  roles: readonly (readonly [MuscleId, Role])[]
}

export const LANDING_LIFTS: readonly LandingLift[] = [
  { id: 'bb_bench_press', short: 'Bench press', name: 'Barbell Bench Press', roles: [['chest', 'direct'], ['triceps', 'indirect'], ['front_delts', 'indirect']] },
  { id: 'bb_back_squat_high_bar', short: 'Back squat', name: 'High-Bar Barbell Back Squat', roles: [['quads', 'direct'], ['glutes', 'direct'], ['adductors', 'indirect']] },
  { id: 'back_pull_up_pronated', short: 'Pull-up', name: 'Pull-Up (pronated, medium-wide)', roles: [['lats', 'direct'], ['biceps', 'indirect'], ['upper_back', 'indirect']] },
  { id: 'bb_rdl', short: 'Romanian deadlift', name: 'Barbell Romanian Deadlift', roles: [['hamstrings', 'direct'], ['glutes', 'direct'], ['lower_back', 'indirect'], ['adductors', 'indirect']] },
  { id: 'barbell_overhead_press_standing', short: 'Overhead press', name: 'Standing Barbell Overhead Press', roles: [['front_delts', 'direct'], ['triceps', 'indirect'], ['side_delts', 'indirect']] },
]
